import { useEffect, useRef } from 'react';
import { threadId } from '../../client/chat/common/store';
import { useToast } from '../../lib/toast';
import { kanzleiChat, kanzleiOpenThread, unreadRows } from './data';

// Zahl der Mandanten mit ungelesenen Nachrichten (Zähler „Übersicht“ in der Seitenleiste).
// Wird einmal im Rahmen benutzt und zeigt dort auch „Neue Nachricht von …“: nicht für Nachrichten,
// die beim Laden schon da waren, und nicht für den gerade offenen Chat.
export function useChatClientsUnread(): number {
  const data = kanzleiChat.useData();
  const open = kanzleiOpenThread.useOpen();
  const toast = useToast();
  const seenUntil = useRef<string | null>(null);

  useEffect(() => {
    if (!data) return;
    const threads = data.clients.flatMap((c) =>
      c.threads.filter((t) => t.latest).map((t) => ({ ...t, at: t.latest!.at, clientId: c.clientId, contactName: c.contactName })),
    );
    const newest = threads.reduce((a, t) => (t.at > a ? t.at : a), '');
    if (seenUntil.current === null) {
      seenUntil.current = newest;
      return;
    }
    const since = seenUntil.current;
    const fresh = threads
      .filter((t) => t.at > since && threadId(t.clientId, t.staffId) !== kanzleiOpenThread.get())
      .sort((a, b) => b.at.localeCompare(a.at));
    if (fresh[0]) toast(`Neue Nachricht von ${fresh[0].contactName}`);
    if (newest > since) seenUntil.current = newest;
  }, [data, toast]);

  return unreadRows(data, open).length;
}

// Ungelesene Nachrichten eines Mandanten (Zähler am Tab „Chat“). Admin: alle Chats, nach eigenem Gelesen-Stand.
export function useChatUnreadForClient(clientId: string): number {
  const data = kanzleiChat.useData();
  const open = kanzleiOpenThread.useOpen();
  return unreadRows(data, open).find((r) => r.clientId === clientId)?.unread ?? 0;
}
